import React from "react";
import { TextNode as RPDFCTextNode, Image, View as RPDFView } from "@surge-global-engineering/react-pdf-components";
import { StyleSheet, View } from "@surge-global-engineering/rpdf-renderer";
import { PdfSlateProfileLinks, PdfTheme } from "../types";
import { getSocialMediaIcons } from "../configs/social-media-icons";

interface SocialProfilesProps {
    profileNode: PdfSlateProfileLinks;
    theme: PdfTheme;
}

const SocialProfiles: React.FC<SocialProfilesProps> = ({ profileNode }) => {

    let smIconSize;
    const { url = [], printAlign } = profileNode;

    const styles = StyleSheet.create({
        container: {
            paddingTop: 10,
        },
        socialAccountCover: {
            marginTop: 5,
            flexDirection: printAlign === "center" ? "column" : "row",
            width: "100%",
            alignSelf: "center",
        },
        socialIconCover: {
            justifyContent: "center",
            alignSelf: "center",
            marginRight: printAlign === "center" ? 0 : 5,
        },
        socialLinkCover: {
            display: "flex",
            flex: printAlign === "center" ? undefined : 1,
            justifyContent: "center",
            alignSelf: "center",
        },
        link: {
            textAlign: printAlign === "center" ? "center" : "left",
        },
        linkSmall: {
            fontSize: 8,
        },
        linkMedium: {
            fontSize: 10,
        },
        linkLarge: {
            fontSize: 12,
        },
        iconSmall: {
            width: 14,
            height: 14,
        },
        iconMedium: {
            width: 16,
            height: 20,
        },
        iconLarge: {
            width: 18,
            height: 18,
        }
    });


    return (
        <>
            <View style={styles.container}>
                {
                    url.map((urlItem, index) => {
                        const { name, username, iconSize } = urlItem;

                        if (iconSize === "medium") {
                            smIconSize = name + "-Medium";
                        } else if (iconSize === "small") {
                            smIconSize = name + "-Small";
                        } else {
                            smIconSize = name + "-Large";
                        }

                        const getSM = getSocialMediaIcons(smIconSize);
                        const smName = getSM?.smLink;
                        const smID = getSM?.id;

                        return (
                                <RPDFView wrap={false} style={styles.socialAccountCover} key={index}>
                                    <RPDFView style={styles.socialIconCover} key={`icon-${smID}`}>
                                        {iconSize === "small" ? <Image key={`icon-${smID}`} src={smName} style={styles.iconSmall} />
                                            : iconSize === "medium" ? <Image key={`icon-${smID}`} src={smName} style={styles.iconMedium} /> :
                                                <Image key={`icon-${smID}`} src={smName} style={styles.iconLarge} />}
                                    </RPDFView>

                                    <RPDFView style={styles.socialLinkCover} hasWrapTextAroundComponent={true}>
                                        {iconSize === "small" ? <RPDFCTextNode  style={[styles.link ,styles.linkSmall]}>{username.replace("https://www.", "")}</RPDFCTextNode>
                                            : iconSize === "medium" ? <RPDFCTextNode style={[styles.link ,styles.linkMedium]}>{username.replace("https://www.", "")}</RPDFCTextNode>
                                                : <RPDFCTextNode wrap={true} style={[styles.link ,styles.linkLarge]}>{username.replace("https://www.", "")}</RPDFCTextNode>}
                                    </RPDFView>
                                </RPDFView>
                        );
                    })
                }
            </View>
        </>
    );
};
export default SocialProfiles;
